import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabClientDetails from '../../form-fields/tab-client-details/tab-client-details';
class AddEditViewReferralTabName extends Component {
  render() {    
    return (
      <div>
        <FormFieldsTabClientDetails 
          {...this.props}
          locked={this.props.locked}
                                                                      // referralMode={this.props.referralMode}
          // referralsourcesList={this.props.referralsourcesList.referralsources}
          referralsourcesList={this.props.referralsourcesList}
        />
      </div>
    );
  }
}
AddEditViewReferralTabName.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
                                                                    // referralMode: PropTypes.number,
  /*** fix make required */
  referralsourcesList: PropTypes.array,
}
AddEditViewReferralTabName = reduxForm({
  form: 'ReferralEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddEditViewReferralTabName);
export default AddEditViewReferralTabName;